import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { toast } from "react-toastify";


export const cancelUploadAPI = async (performanceId: number, item: any, onUpdate?: (data: any) => void) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/performances/mux/${performanceId}/delete`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    const data = await response.json();
    if (!data.success) {
      throw new Error(data.message || data.data?.error_message || "Failed to cancel upload");
    }

    const activeVideos = JSON.parse(localStorage.getItem("active_videos") || "{}");
    delete activeVideos[performanceId];
    localStorage.setItem("active_videos", JSON.stringify(activeVideos));

    const history = JSON.parse(localStorage.getItem("upload_history") || "{}");
    delete history[performanceId];
    localStorage.setItem("upload_history", JSON.stringify(history));

    if (onUpdate) {
      onUpdate({
        ...item,
        mux_playback_id: null,
        mux_asset_id: null,
        mux_playback_url: null,
        status: null
      });
    }
    return { success: true, data };
  } catch (err: unknown) {
    const error = err instanceof Error ? err.message : "Cancel failed";
    console.error("Error cancelling upload:", error);
    return { success: false, error };
  }
};

function MuxCancelUploadAction({ item, onUpdate }: any) {
  const [loading, setLoading] = useState(false);

  const handleCancel = async () => {
    if (!window.confirm("Are you sure you want to cancel this talktape upload?")) return;

    setLoading(true);
    try {
      const result = await cancelUploadAPI(item.performance_id, item, onUpdate);
      
      if (!result.success) {
        throw new Error(result.error);
      }

      toast.info(result.data?.message);
    } catch (err: unknown) {
      const error = err instanceof Error ? err.message : "Cancel failed";
      console.error("Error cancelling uploading talktape:", error);
      toast.warn(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Cancel Upload Talktape" enterDelay={0} leaveDelay={0}>
      <span>
      <ClearIcon
        className="music-icon remove"
        onClick={handleCancel}
        style={{
          cursor: "pointer",
          opacity: loading ? 0.5 : 1,
          color: loading ? "#ccc" : "#d32f2f",
        }}
      />
    </span>
    </Tooltip>
  );
}

export default MuxCancelUploadAction;